import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/i18n/I18nProvider";
import PageHeader from "@/components/PageHeader";
import PatientJourney from "@/components/PatientJourney";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Journey() {
  const t = useT();
  const [patients, setPatients] = useState([]);
  const [patientId, setPatientId] = useState("");

  useEffect(() => { api.get("/patients").then((r) => { setPatients(r.data); if (r.data.length) setPatientId(r.data[0].id); }); }, []);

  return (
    <div className="p-6 sm:p-8 max-w-[1000px]">
      <PageHeader title={t("journey.title")} subtitle={t("journey.subtitle")}>
        <Select value={patientId} onValueChange={setPatientId}>
          <SelectTrigger className="w-64" data-testid="journey-patient-select"><SelectValue placeholder={t("journey.selectPatient")} /></SelectTrigger>
          <SelectContent>{patients.map((p) => <SelectItem key={p.id} value={p.id}>{p.patient_code} · {p.first_name} {p.last_name}</SelectItem>)}</SelectContent>
        </Select>
      </PageHeader>
      {patientId && <PatientJourney patientId={patientId} />}
    </div>
  );
}
